export default __webpack_public_path__ + "static/media/OGHarajuku.408988f7.webp";